module.exports = __webpack_public_path__ + "img/appIcon-menu--Components--active.e71b377c.svg";